import { Navigate, Outlet } from "react-router";
import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { ACTION_PLAN_TEMPLATE, useFoodpilotContext, VIEW } from "src/context/FoodpilotContext";

export const ActionPlanTemplatesProtection = () => {
    const { canUser } = useFoodpilotContext();
    const { isFeatureActivated, isLoading } = useApplicationParameters();

    if (isLoading) return null;

    return canUser(VIEW, ACTION_PLAN_TEMPLATE) && isFeatureActivated("FS-actionPlan") ?
            <Outlet />
        :   <Navigate to="/settings" replace />;
};
